// extracted by mini-css-extract-plugin
export default {"technologiesTitle":"Technologies_technologiesTitle__ZjJN9","technologiesDiv":"Technologies_technologiesDiv__yjG+I","listSkills":"Technologies_listSkills__bWl-X"};